/**
 *
 * @param {Spinner} spinner
 */
export function setupLayersControls(spinner) {
  if (!spinner.hideInterior && spinner.interiorImage) {
    spinner.addLayerButton("interior");
  }

  if (
    !spinner.hideShowcase &&
    spinner.availableLayers.length > 1 &&
    spinner.availableLayers.indexOf("showcase") !== -1
  ) {
    spinner.addLayerButton("showcase");
  }

  if (
    !spinner.hideLights &&
    spinner.availableLayers.length > 1 &&
    spinner.availableLayers.indexOf("lights") !== -1
  ) {
    spinner.addLayerButton("lights");
  }

  if (
    !spinner.hideDoors &&
    spinner.availableLayers.length > 1 &&
    spinner.availableLayers.indexOf("doors") !== -1
  ) {
    spinner.addLayerButton("doors");
  }

  if (
    (spinner.availableLayers.length > 1 || spinner.interiorImage) &&
    spinner.availableLayers.indexOf("default") !== -1
  ) {
    spinner.addLayerButton("default");
  }

  if (!spinner.hideGallery && spinner.galleryImages.length) {
    spinner.addActionButton("gallery", () => {
      spinner.showCarousel(spinner.galleryImages).catch(console.error);
    });
  }
}
